<div class="min-h-[50vh] flex flex-col items-center justify-center text-center error-page">
  <div class="text-4xl font-bold flex items-center justify-center mb-4">
    <mat-icon class="material-symbols-outlined text-[30px] icon-erreur align-middle mr-[10px]">
      {{icon}}
    </mat-icon>
    {{ 'PAGE_ERREUR.TITRE' | translate }} {{code}}
  </div>

  <p class="mb-4">{{codeMessage | translate }}</p>

  <button mat-raised-button class="btn-primary-novo" (click)="redirectToAcceuil()">
    {{ 'PAGE_ERREUR.PAGE_ACCEUIL' | translate }}
  </button>
</div>
